import { take, put, call } from 'redux-saga/effects';
import moment from 'moment';

import {
  requestSystemsInfoStart,
  requestSetSystemsInfo,
  requestSystemsInfoSuccess,
  requestSystemsInfoFail
} from '@reducers/systems';


import CONFIG from '@root/config/config.next';
// const url = CONFIG.backendEndpoint;

export function* setSystemsInfo(data) {

  /*console.log('setSystemsInfo : ', data);*/

  try {
    yield put(requestSetSystemsInfo(status));

  } catch (error) {

    console.error('requestSystemsInfoFail : ', error)
    yield put(requestSystemsInfoFail(error));
  }
}


export function* watchPageSettingInfo() {

  /*console.log('[sages] watchPageSettingInfo : ✅');*/

  while (true) {
    const { payload: { data } } = yield take(requestSystemsInfoStart);
    yield call(setSystemsInfo, data);
    // yield call(requestSystemsInfo, data);
  }
}
